<template>
  <div class="imdiv" :class="{hide: hide}" >
    <div class="square-filler" >
      <transition name="fade">
        <img v-if="seen" :src="imageUrl" :alt="artist.formatted_name" class="main" v-on:click="zoom"  />
      </transition>
    </div>
    <div class="greybar">
        <div>
          <div class="a-name"><ix-router-link :to="portfolioUrl">{{ artist.formatted_name }}</ix-router-link></div>
          <div>
            <small-button v-on:click="zoom">{{ $nippets.portfolio.view }}</small-button>
          </div>
        </div>
        <div class="likebox-holder"><like-box :imageId="image.image_id" v-on:click="handleLikeClick" /></div>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import LikeBox from '@/components/buttons/LikeBox.vue'
export default {
  mixins: [ViewablePanel],
  components: {
    LikeBox
  },
  props: {
    image: Object
  },
  data () {
    return {
      imageUrl: '',
      alt: '',
      artist: {},
      hide: false
    }
  },
  created() {
    this.init()
  },
  computed: {
    portfolioUrl () {
      if(!this.artist) return ''
      if(this.animation) return '/animators/' + this.artist.portfolio_url
      else return '/artists/' + this.artist.portfolio_url
    }
  },
  methods: {
    async handleLikeClick(liked) {
      if(!liked) {
        this.hide = true
        await this.$k.waitfor(300)
      }
      this.$emit('likeClicked')
    },
    async init () {
      if(!this.image) return
      this.imageUrl = this.$k.getImageCrop320(this.image.url)
      this.artist = await this.$store.dispatch('fetchArtistById', this.image.artist_id)
    },
    zoom() {
      this.$emit('zoom', this.image)
    }
  },
  watch: {
    image () {
      this.init()
    }
  }
}
</script>

<style scoped>
.imdiv{
  transition: all 0.3s linear;
}
.imdiv.hide{
  opacity:0;
}

.square-filler{
  pointer-events: all;
}

img.main{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
}
.square-filler{
  position:relative;
  overflow:hidden;
}
.imdiv:hover img.main{
  width:107%;
}
</style>